export default "__VITE_ASSET__YruHyXOZ__"